<template>
  <el-card  v-if="selectedSalesOrder!=null" v-loading="salesOrderLoading || loading || processingSales" >
    <!-- Controls -->
    <div class="hidden-xs-only" style="position:relative;float:right;z-index:1000">

      <el-button type="primary" plain size="small" @click="editSalesOrder" :disabled="!canEditSelectedSalesOrder(this)"><i class="el-icon-edit"></i></el-button>
      <el-dropdown size="small"   class="ml-10">
        <el-button type="primary" size="small">
          Actions<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="markAsDraft" :disabled="!isRepCanEdit(this) && !isCurrentUserAdmin" v-if="canReturnToDraft(this)" >{{ $t('sales_orders.actions.markAsDraft') }}</el-dropdown-item>
          <el-dropdown-item @click.native="returnAsConfirmed" :disabled="!isRepCanEdit(this) &&  !isCurrentUserAdmin" v-if="canReturnToConfirmed(this)">{{ $t('sales_orders.actions.marsAsToProcess') }}</el-dropdown-item>
          <el-dropdown-item @click.native="markAsConfirmed" :disabled="!isRepCanEdit(this) && !isCurrentUserAdmin" v-if="statusCode=='DRAFT' || statusCode=='DRAFT_EXTERNAL'" >{{ $t('sales_orders.actions.confirm') }}</el-dropdown-item>
          <el-dropdown-item @click.native="markAsCompleted" :disabled="!isRepCanEdit(this) && !isCurrentUserAdmin" v-if="statusWeight >= 33" >{{ $t('sales_orders.actions.markAsCompleted') }}</el-dropdown-item>
          <el-dropdown-item @click.native="createInvoice" :disabled="!isRepCanEdit(this) && !isCurrentUserAdmin" v-if="canInvoicedSelectedSalesOrder(this) && isInvoicingModuleactive === true">{{ $t('sales_orders.actions.bill') }}</el-dropdown-item>
          <el-dropdown-item @click.native="process" :disabled="processingSales || (!isRepCanEdit(this) && !isCurrentUserAdmin)" v-if="$can('manage','SalesOrders') && (statusWeight >= 10 && statusWeight < 20)">{{ $t('sales_orders.actions.process') }}</el-dropdown-item>
          <el-dropdown-item @click.native="processAuto" :disabled="processingSales || (!isRepCanEdit(this) && !isCurrentUserAdmin)" v-if="$can('manage','SalesOrders') && (statusWeight >= 10 && statusWeight < 20) && isSAQProcessModuleactive" >{{ $t('sales_orders.actions.automaticProcess') }}</el-dropdown-item>
          <el-dropdown-item @click.native="processAuto" :disabled="processingSales || (!isRepCanEdit(this) && !isCurrentUserAdmin)" v-if="$can('manage','SalesOrders') && (statusCode === 'REJECTED') && isSAQProcessModuleactive" >{{ $t('sales_orders.actions.automaticReProcess') }}</el-dropdown-item>
          <el-dropdown-item
            v-for="(customStatus, index) in customStatuses"
            :key="index"
            :disabled="!isRepCanEdit(this) && !isCurrentUserAdmin"
            @click.native="updateCustomStatus({customStatus, salesOrderId:selectedSalesOrder.id})"
            v-if="canShow({customStatus, actualStatus: status}) && isPackageUnique">
              {{$t('sales_orders.custom_statuses.'+customStatus.action)}}
          </el-dropdown-item>
          <!-- <el-dropdown-item @click.native="confirmSAQ(selectedSalesOrder.id)" v-if="isPackaged && statusWeight < 30">Confirmer SAQ</el-dropdown-item> -->
          <el-dropdown-item @click.native="markAsVoided" :disabled="!canCancelSelectedSalesOrder(this) || (!isRepCanEdit(this)  && !isCurrentUserAdmin)">{{$t('sales_orders.actions.void')}}</el-dropdown-item>
          <el-dropdown-item @click.native="deleteSalesOrder" :disabled="!canDeleteSelectedSalesOrder(this) || (!isRepCanEdit(this) && !isCurrentUserAdmin)">{{$t('sales_orders.actions.delete')}}</el-dropdown-item>
          <el-dropdown-item @click.native="duplicate" divided><i class="mdi mdi-content-copy" />{{$t('sales_orders.actions.duplicate')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown size="small" type="default" class="ml-10">
        <el-button type="primary" size="small">
          <i class="el-icon-download"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadSalesOrderReport({salesOrder : selectedSalesOrder,type:'PDF'})"><i class="mdi mdi-file-pdf"/> PDF</el-dropdown-item>
          <el-dropdown-item :disabled="!canDownloadPackageInfos" @click.native="downloadSalesOrderReport({salesOrder : selectedSalesOrder,type:'Excel'})"><i class="mdi mdi-file-excel"/> Excel</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
      <el-row>
        <el-page-header @back="$emit('close');" style="float:left;">
          <div slot="title">
            <span class="hidden-sm-and-down"></span>
          </div>
          <div slot="content">
            <span class="fs-20"><i v-if="!isSelectedSalesOrderQuantitiesValid" class="mdi mdi-alert ml-5">&nbsp;</i>{{selectedSalesOrder.soNumber}}</span><span v-if="isB2B"><el-image src="/logo-panorama.png" style="margin-left:10px;height:16px;"></el-image></span>
          </div>
        </el-page-header>
      </el-row>
      <el-row class="hidden-sm-and-up mt-10" justify="end" style="text-align:center;margin-bottom:10px;">
        <el-col>
          <el-button type="primary" plain size="small" @click="editSalesOrder" :disabled="!canEditSelectedSalesOrder(this)"><i class="el-icon-edit"></i></el-button>
          <el-dropdown size="small" style="margin-left:10px;">
            <el-button type="primary" size="small">
              Actions<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="markAsDraft" v-if="canReturnToDraft(this)" >{{ $t('sales_orders.actions.markAsDraft') }}</el-dropdown-item>
              <el-dropdown-item @click.native="returnAsConfirmed" v-if="canReturnToConfirmed(this)" >{{ $t('sales_orders.actions.marsAsToProcess') }}</el-dropdown-item>
              <el-dropdown-item @click.native="markAsConfirmed" v-if="statusCode=='DRAFT'" >{{ $t('sales_orders.actions.confirm') }}</el-dropdown-item>
              <el-dropdown-item @click.native="createInvoice" v-if="canInvoicedSelectedSalesOrder(this)">{{ $t('sales_orders.actions.bill') }}</el-dropdown-item>
              <el-dropdown-item @click.native="process" :disabled="processingSales" v-if="$can('manage','salesOrders') && (statusWeight >= 10 && statusWeight < 20)">{{ $t('sales_orders.actions.process') }}</el-dropdown-item>
              <el-dropdown-item @click.native="processAuto" :disabled="processingSales" v-if="$can('manage','SalesOrders') && (statusWeight >= 10 && statusWeight < 20) && isSAQProcessModuleactive" >{{ $t('sales_orders.actions.automaticProcess') }}</el-dropdown-item>
              <el-dropdown-item v-for="(customStatus, index) in customStatuses" :key="index" @click.native="updateCustomStatus({customStatus, salesOrderId:selectedSalesOrder.id})" v-if="canShow({customStatus,actualStatus:selectedSalesOrder.status})">{{$t('sales_orders.custom_statuses.'+customStatus.action)}}</el-dropdown-item>
              <el-dropdown-item @click.native="markAsVoided" :disabled="!canCancelSelectedSalesOrder(this)">{{$t('sales_orders.actions.void')}}</el-dropdown-item>
              <el-dropdown-item @click.native="deleteSalesOrder" :disabled="!canDeleteSelectedSalesOrder(this)">{{$t('sales_orders.actions.delete')}}</el-dropdown-item>
              <el-dropdown-item @click.native="duplicate" divided>{{$t('sales_orders.actions.duplicate')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown size="small" type="default" style="margin-left:10px;">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="downloadSalesOrderReport({salesOrder : selectedSalesOrder,type:'PDF'})"><i class="mdi mdi-file-pdf"/> PDF</el-dropdown-item>
              <el-dropdown-item @click.native="downloadSalesOrderReport({salesOrder : selectedSalesOrder,type:'Excel'})"><i class="mdi mdi-file-excel"/> Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    <el-divider/>
    <div class="box grow scrollable only-y pr-10 mr-0" :style="height">
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane name="info">
          <span slot="label"><i class="el-icon-info"></i> <span class="hidden-sm-and-down"> Informations</span></span>
          <el-alert v-if="hasExternalRejectedCodes" :title="$t('common.Warning')" type="warning" :closable="false" show-icon>
            <p v-for="(rejection, rejIdx) in getExternalRejectedCodes" :key="rejIdx">

              <span>{{$t(`packages.rejectedReasons_${rejection.reason}`)}}</span>
              <span v-if="rejection.commentaries != null"><br><br><strong>{{$t('sales_orders.commentariesField')}}</strong> {{ rejection.commentaries }}</span>
              <template v-if="rejection.reason === 'PRODUCT_INVALID_UVC' && rejection.invalidUvcItems && rejection.invalidUvcItems.length">
                <br><br><strong>{{ $t('packages.invalidUvcItemsLabel') }}</strong>
                <ul style="margin: 5px 0 0 0; padding-left: 20px;">
                  <li v-for="(uvcItem, uvcIdx) in rejection.invalidUvcItems" :key="uvcIdx">
                    <strong>{{ uvcItem.productNumber }}</strong><span v-if="uvcItem.productName"> &mdash; {{ uvcItem.productName }}</span><span v-if="uvcItem.quantiteModulo != null"> ({{ $t('packages.invalidUvcUvcQtyLabel') }}: {{ uvcItem.quantiteModulo }})</span>
                  </li>
                </ul>
              </template>
              <!-- <p v-if="rejection.commentaries != null">Commentaires : {{ rejection.commentaries }}</p> -->
            </p>
          </el-alert>
          <!-- <el-alert title="Confirmation de la commande" type="info" v-if="!selectedSalesOrder.invalid && canConfirmSelectedSalesOrder">
            <p>Vous pouvez dès maintenant confirmer la commande.</p>
            <el-button type="info" size="small" plain @click="markAs('emit')">Confirmer</el-button>

           </el-alert> -->
          <el-row style="margin-left:10px;font-size:14px;" :gutter="10" v-if="selectedSalesOrder!=null">
            <el-col v-if="selectedSalesOrder.createdBy != null">
                <span class="fs-12 secondary-text" v-if="selectedSalesOrder.createdAt!=null">{{$t('common.createdAtField')}} {{_moment(selectedSalesOrder.createdAt, 'LLL')}} par {{selectedSalesOrder.createdBy.firstName}} {{selectedSalesOrder.createdBy.lastName}}</span>
            </el-col>
          </el-row>
          <el-row style="margin-left:10px;font-size:14px;" :gutter="10" v-if="selectedSalesOrder!=null">
            <el-col>
                <span v-if="selectedSalesOrder.rep" class="fs-12 secondary-text">{{$t('invoices.repField')}} {{selectedSalesOrder.rep.firstName}} {{selectedSalesOrder.rep.lastName}}</span>
            </el-col>
          </el-row>
          <el-row style="margin-left:10px;font-size:14px;" :gutter="10" v-if="selectedSalesOrder!=null">
            <el-col>
                <span class="fs-12 secondary-text" v-if="selectedSalesOrder.invoicedAt!=null">{{$t('invoices.billedAtField')}} {{_moment(selectedSalesOrder.invoicedAt, 'LL')}}</span>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane name="packages" :lazy="true">
          <span slot="label"><i class="el-icon-box"></i> <span class="hidden-sm-and-down"> {{$t('packages.packageTabTitle')}} <span v-if="selectedSalesOrder.packages!=null && selectedSalesOrder.packages.length>0">({{selectedSalesOrder.packages.length}})</span></span></span>
          <packageTable :packages="selectedSalesOrder.packages" :salesOrderNumber="selectedSalesOrder.soNumber" @packageUpdated="refreshPackages"></packageTable>
        </el-tab-pane>
        <el-tab-pane name="invoices" :lazy="true" v-if="isInvoicingModuleactive">
          <span slot="label"><i class="mdi mdi-file-document"></i> <span class="hidden-sm-and-down"> {{$t('invoices.invoiceTabTitle')}} <span v-if="selectedSalesOrder.invoices.length>0">({{selectedSalesOrder.invoices.length}})</span></span></span>
          <InvoicesBaseSummary :invoices="selectedSalesOrder.invoices"></InvoicesBaseSummary>
        </el-tab-pane>
        <!-- <el-tab-pane>
          <span slot="label"><i class="el-icon-watch"></i> <span class="hidden-sm-and-down"> Historiques</span></span>
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in selectedSalesOrderHistoricActivities"  :key="index" :icon="activity.icon" :color="activity.color">
              <div>
                <span style="">{{activity.content}}</span><br>
                <span style="color:#909399">{{_moment(activity.timestamp,'LL')}}</span>
              </div>
          </el-timeline-item>
        </el-timeline>
        </el-tab-pane> -->
      </el-tabs>
      <!-- End tabs -->
      <el-card shadow="never" class="mt-10">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">Client : </span>
              <span class="fs-14 secondary-text">
                <PortausLink v-if="selectedSalesOrder.customer!=null" :label="customerName(selectedSalesOrder.customer)" :id="selectedSalesOrder.customer.id" path="/customers/"></PortausLink>
              </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">{{ $t('common.statusField') }} </span>
              <span class="fs-14 secondary-text">
                <SalesOrderStatusTag :status="status" />
              </span>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="showMoreInfos">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">{{$t('sales_orders.Sales_order_number')}} : </span>
              <span class="fs-14 secondary-text">{{selectedSalesOrder.soNumber}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">{{$t('sales_orders.Reference_number')}} : </span>
              <span class="fs-14 secondary-text">{{selectedSalesOrder.reference}}</span>
          </el-col>
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">{{ $t('sales_orders.paidByAgent') }} : </span>
              <span class="fs-14 secondary-text">{{ selectedSalesOrder.paidByAgent === true ? $t('common.yes') : $t('common.no') }}</span>
            </el-col> -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">{{ $t('sales_orders.salesOrderDateField') }}</span>
              <span class="fs-14 secondary-text" v-if="selectedSalesOrder.date!=null">{{_moment(selectedSalesOrder.date)}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">{{$t('sales_orders.deliveryDateField')}}</span>
              <span class="fs-14 secondary-text" v-if="selectedSalesOrder.expectedDeliveryDate!=null">{{_moment(selectedSalesOrder.expectedDeliveryDate)}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">{{ $t('sales_orders.deliveryTypeField') }} </span>
              <span class="fs-14 secondary-text" v-if="selectedSalesOrder.deliveryType!=null">{{deliveryType}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="selectedSalesOrder.extraInfo!=null && selectedSalesOrder.extraInfo.location!=null">
              <BranchTile class="fs-14" :class="isSalesOrderLocationInvalid" style="border:1px dashed #DCDFE6;padding:10px;margin-top:10px;max-width:300px;" :location="selectedSalesOrder.extraInfo.location.content"></BranchTile>
          </el-col>
        </el-row>
        <el-row style="text-align:center;margin-bottom:-20px;" class="m-0">
          <el-button type="text" v-if="!showMoreInfos" @click="showMoreSOInfos(true)"><i class="el-icon-arrow-down"></i></el-button>
          <el-button type="text" v-if="showMoreInfos" @click="showMoreSOInfos(false)"><i class="el-icon-arrow-up"></i></el-button>
        </el-row>
      </el-card>
      <el-card shadow="never" class="mt-10">
        <el-row :gutter="20" justify="center">
          <el-col :xs="24" :sm="24" :md="124" :lg="12" :xl="12">
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <span class="fs-14 secondary-text">{{$t('sales_orders.billedToField')}} </span>
                  <span class="fs-14 secondary-text" v-if="customerType==1 && selectedSalesOrder.billingContact!=null">{{getName(selectedSalesOrder.billingContact)}}</span>
                  <span class="fs-14 secondary-text" v-if="customerType==0 ">{{customerName(selectedSalesOrder.customer)}}</span>
              </el-col>

            </el-row>
            <el-row style="margin-top:20px;" v-if="showMoreBillingInfos">
                <AddressCard  v-if="selectedSalesOrder.billingAddress!=null" :address="selectedSalesOrder.billingAddress" :ctrlVisible="false" :headerVisible="false"></AddressCard>
            </el-row>
            <el-row style="text-align:center;margin-bottom:-10px;" class="m-0">
              <el-button type="text" v-if="!showMoreBillingInfos" @click="showMoreSOBillingInfos(true)"><i class="el-icon-arrow-down"></i></el-button>
              <el-button type="text" v-if="showMoreBillingInfos" @click="showMoreSOBillingInfos(false)"><i class="el-icon-arrow-up"></i></el-button>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="124" :lg="12" :xl="12">
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <span class="fs-14 secondary-text">{{$t('sales_orders.Deliver_to')}} : </span>
                  <span class="fs-14 secondary-text" v-if="customerType==1 && selectedSalesOrder.shippingContact!=null">{{getName(selectedSalesOrder.shippingContact)}}</span>
                  <span class="fs-14 secondary-text" v-if="customerType==0 ">{{customerName(selectedSalesOrder.customer)}}</span>
              </el-col>
            </el-row>
            <el-row style="margin-top:20px;" v-if="showMoreShippingInfos">
                <AddressCard  v-if="selectedSalesOrder.shippingAddress!=null" :address="selectedSalesOrder.shippingAddress" :ctrlVisible="false" :headerVisible="false"></AddressCard>
            </el-row>
            <el-row style="text-align:center;margin-bottom:-10px;" class="m-0">
              <el-button type="text" v-if="!showMoreShippingInfos" @click="showMoreSOShippingInfos(true)"><i class="el-icon-arrow-down"></i></el-button>
              <el-button type="text" v-if="showMoreShippingInfos" @click="showMoreSOShippingInfos(false)"><i class="el-icon-arrow-up"></i></el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
      <el-divider/>
      <SalesOrderItemEditor :items="selectedSalesOrder.lines" :packages="selectedSalesOrder.packages"></SalesOrderItemEditor>
      <el-row>
        <table style="width:100%;margin-top:20px;">
            <tr>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{ $t('sales_orders.subTotalField') }} </td>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(selectedSalesOrder.subTotal,'currency')}}</td>
            </tr>
            <tr v-if="selectedSalesOrder.discount != null">
              <td class="fs-14 secondary-text" style="text-align:right;">{{ $t('sales_orders.rebateField') }} </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">
                <span v-if="discountType==1">({{selectedSalesOrder.discount.value}}%) ({{$n(selectedSalesOrder.discount.amount, 'currency')}})</span>
                <span v-else>
                  <span v-if="selectedSalesOrder.discount.netType=='TOTAL'">({{$n(selectedSalesOrder.discount.value, 'currency')}})</span>
                </span>
              </td>
            </tr>
            <tr v-for="(tax, index) in selectedSalesOrder.taxes" :key="index">
              <td class="fs-14 secondary-text" style="text-align:right;">{{tax.label}} <span class="hidden-md-and-down">({{tax.taxNumber}})</span> : </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency')}}</td>
            </tr>
            <tr>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{ $t('sales_orders.totalField') }} </td>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(selectedSalesOrder.total,'currency')}}</td>
            </tr>
            <tr v-if = "showTotalBillableAmount">
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{ $t('sales_orders.totalBillableAmount') }} </td>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(selectedSalesOrder.subTotalBillable,'currency')}}</td>
            </tr>
        </table>
      </el-row>
      <el-divider/>
      <div v-if="selectedSalesOrder.notes!=null && selectedSalesOrder.notes!==''">
        <h5>Notes</h5>
        <el-row style="margin-bottom:50px;">
          <el-col>
            <span class="fs-14 secondary-text">{{selectedSalesOrder.notes}}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <InvoiceEditor :visible="invoiceEditorVisible" :editInvoice="invoiceToEdit" @close="closeInvoiceEditor" @created="invoiceCreated"></InvoiceEditor>
  </el-card>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import AddressUtils from "@/utils/address-utils";
import AddressCard from '@/components/address/Address-Card'
import InvoiceEditor from '@/components/invoice/invoice-editor'
import InvoicesBaseSummary from '@/components/invoice/invoices-base-summary'
import BranchTile from '@/components/Branch-tile'
import SalesOrderItemEditor from '@/components/salesOrder/sales-order-items-editor'
import customStatusUtils from '@/utils/custom-status-utils'
import packageTable from '@/components/package/package-table-v2'
import PortausLink from '@/components/portaus-link'
import InvoiceAPI from '@/services/API/invoice'
import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'
import packageAPI from '@/services/API/package'
import dayjs from 'dayjs';
export default {
  name : 'Sales-Order-view',
  props : {

  },
  data() {
    return {
      pdfCreating : false,
      window : {
        width:0,
        height : 0,
      },
      invoiceEditorVisible:false,
      invoiceToEdit : null,
      showMoreInfos : true,
      showMoreBillingInfos : true,
      showMoreShippingInfos : true,
      loading : false,
      processingSales: false,
      activeTab: 'info',
    };
  },components : {
    InvoiceEditor,
    AddressCard,
    BranchTile,
    SalesOrderItemEditor,
    packageTable,
    InvoicesBaseSummary,
    PortausLink,
    SalesOrderStatusTag
    },
    methods : {
      refreshPackages(){
        this.selectSalesOrder({salesOrderId : this.selectedSalesOrder.id, index:this.selectedIndex});
      },
      duplicate () {
        this.$emit('duplicate', this.selectedSalesOrder);
      },
      showMoreSOInfos(show){
        this.showMoreInfos=show;
      },
      showMoreSOBillingInfos(show){
        this.showMoreBillingInfos=show;
      },
      showMoreSOShippingInfos(show){
        this.showMoreShippingInfos=show;
      },
      processAuto(event){
        this.process(event, true);
      },
      process(event, automatic = false){
        if (this.processingSales) return;
        this.processingSales = true;

        return new Promise((resolve, reject) => {
          // On valide si le traitement se fait avant la date prescrite
          if (dayjs(this.selectedSalesOrder.date).isAfter(dayjs())) {
              this.$confirm(this.$i18n.t('sales_orders.processBeforDateWarning'), this.$i18n.t('common.Warning'), {
                  confirmButtonText: this.$i18n.t('common.continue'),
                  cancelButtonText: this.$i18n.t('common.cancel'),
                  type: 'warning',
                  distinguishCancelAndClose: true,
                })
                .then(() => {
                  resolve();
                }).catch((err) => {
                  this.$message.warning(this.$i18n.t('sales_orders.processCanceled'));
                  reject();
                })
            } else {
              resolve();
            }
        })
        .then(() => {
          // On valide si le client a un indicateur pour facturer avant de traiter la commande.
          if(!this.invoiced  && (this.selectedSalesOrder.customer.invoiceBeforeProcessing==null || this.selectedSalesOrder.customer.invoiceBeforeProcessing==true)){
            return this.$confirm(this.$i18n.t('sales_orders.billFirstWarning'), this.$i18n.t('common.Warning'), {
                confirmButtonText: this.$i18n.t('sales_orders.yesChargeBeforeProcessing'),
                cancelButtonText: this.$i18n.t('sales_orders.noDontChargeBeforeProcessing'),
                type: 'warning',
                distinguishCancelAndClose: true,
              }).then(()=>{
                this.createInvoice()
              }).catch((action)=>{
                if(action=='cancel'){
                    return this.processSalesOrder(automatic);
                }
                return null;
              })
          }else {
            return this.processSalesOrder(automatic);
          }
        }).catch((err) => {
          return null;
        }).finally(() => {
          this.processingSales = false;
        })
        

        
      },
      canShow({customStatus, actualStatus, conditions, testedStatus}){
        return customStatusUtils.canShow({
          customStatus,
          actualStatus,
          conditions,
          testedStatus,
          customStatuses: this.customStatuses,
          vm:this});
      },
      getName(contact){

        const firstName = contact.firstName != null ? contact.firstName : '';
        const lastName = contact.lastName != null ? contact.lastName : '';
        
        const contactName = `${firstName} ${lastName}`;
        
        if (_.trim(contactName) != '' ){
          return `${contactName} (${contact.workEmail})`;
        }
        return "Unnamed contact" + " ("+contact.workEmail+")";
      },
      deleteSalesOrder(){
        this.deleteSelectedSalesOrder()
          .then(deleted=>{
            if(deleted){
              this.$emit('close');
            }
          })
      },
      invoiceCreated(invoiceId){
        this.closeInvoiceEditor();
        this.selectSalesOrder({salesOrderId : this.selectedSalesOrder.id, index:this.selectedIndex});
        // if(this.selectedSalesOrder.status.code=='TO_PROCESS'){
        //   this.markAs('charge');
        // }
        this.invalidateInvoiceList();
      },
      editSalesOrder(){
          if (this.selectedSalesOrder.status.code === 'IN_PROCESS') {
            this.$alert(this.$i18n.t('sales_orders.no_edition_warning_text'), this.$i18n.t('common.Warning'), {
                confirmButtonText: 'OK',
                callback: action => {
                  // do nothing
                }
              });
          } else if (this.selectedSalesOrder.status.code === 'IN_AUTO_PROCESS') {
            this.$alert(this.$i18n.t('sales_orders.no_edition_warning_text_auto_processing'), this.$i18n.t('common.Warning'), {
                confirmButtonText: 'OK',
                callback: action => {
                  // do nothing
                }
              });
          } else {
            this.$emit('editSalesOrder');
          }

      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      _moment(datetime, format='LL'){
        return moment(datetime).format(format);

  		},
      formatAddressLine(address, line){
        if(line==1){
          return AddressUtils.getAddressLine1(address);
        }else if (line==2){
          return AddressUtils.getAddressLine2(address);
        }else if(line==3){
          return AddressUtils.getAddressLine3(address);
        }
      },
      createInvoice(){
        this.setLoadingSalesOrder(true);
        InvoiceAPI.convertSalesOrdersToInvoice({ salesOrdersId: this.selectedSalesOrder.id})
          .then((invoice) => {
            this.invoiceToEdit = invoice;
            this.setLoadingSalesOrder(false);
            this.openInvoiceEditor();
          }).catch((err) => {
            console.log(err);
            this.setLoadingSalesOrder(false);
          })


      },
      openInvoiceEditor(){
        this.invoiceEditorVisible=true;
      },
      closeInvoiceEditor(){
        this.invoiceEditorVisible=false;
        this.invoiceToEdit=null;
      },
      openCustomer(customerId, tab){
        var index='/customers/'+customerId+"?activeTab="+tab;
  			this.$router.push(index);
      },
      ...mapActions('salesOrders',['confirmSAQ','markAsConfirmed','markAsVoided','markAs','deleteSelectedSalesOrder','markAsInvoiced','markAsDraft','processSalesOrder','downloadSalesOrderReport','updateCustomStatus','returnAsConfirmed','markAsCompleted','selectSalesOrder','setLoadingSalesOrder', 'updateSalesOrderPackage']),
      ...mapActions('invoiceEditor',['convertSalesOrderToInvoice']),
      ...mapActions('statuses',['fetchInvoiceStatuses']),
      ...mapActions('controlData',['fetchDeliveryTypes']),
      ...mapActions('invoices',['invalidateInvoiceList']),
    },
    computed : {
      isB2B(){
        return _.get(this.selectedSalesOrder, 'origin') === 'B2B';
      },
      isSalesOrderLocationInvalid(){
        if (this.isLocationInvalid) {
          return "bg-danger-lighter";
        }
      },
      showTotalBillableAmount () {
        if (_.get(this.selectedSalesOrder, 'subTotalBillable') == null) return false;
        return _.get(this.selectedSalesOrder, 'subTotalBillable') != _.get(this.selectedSalesOrder, 'total');
      },
      canDownloadPackageInfos (){
        return this.isPackageUnique;
      },
      isPackageUnique () {
        return _.size(this.selectedSalesOrder.packages) === 1;
      },
      isPackaged () {
        return !_.isEmpty(this.selectedSalesOrder.packages);
      },
      discountType () {
        return _.get(this.selectedSalesOrder, 'discount.type');
      },
      customerType () {
        return _.get(this.selectedSalesOrder, 'customer.type');
      },
      status () {
        return _.get(this.selectedSalesOrder, 'status');
      },
      statusCode () {
        return _.get(this.selectedSalesOrder, 'status.code');
      },
      statusWeight () {
        return _.get(this.selectedSalesOrder, 'status.weight');
      },
      customerId(){
        if(this.selectedSalesOrder!=null && this.selectedSalesOrder.customer!=null) {this.selectedSalesOrder.customer.id;}
        else{
          return null;
        }

      },
      customStatuses(){
        if(localStorage.SALES_ORDER_CUSTOM_STATUS==null)return [];
        return JSON.parse(localStorage.SALES_ORDER_CUSTOM_STATUS);
      },
      deliveryType(){
  			if(this.selectedSalesOrder.deliveryType!=null){
          return _.get(this.deliveryTypeByLanguage({lang:this.$i18n.locale,id:this.selectedSalesOrder.deliveryType.id}), 'name');
  			}
  			return null;
  		},
      height(){
        return "height :"+(this.window.height-240) + "px"
      },
      invoiced(){
        let invoiced = false;
        if (this.selectedSalesOrder !== null) {
          _.forEach(this.selectedSalesOrder.invoices, i=>{
            if (i.status.code != 'VOIDED') invoiced = true;
          })
        }
        return invoiced;
      },
      ...mapState('salesOrders', [ 'selectedSalesOrder','salesOrderLoading', 'selectedIndex','selectedSalesOrderHistoricActivities']),
      ...mapGetters('salesOrders', ['getExternalRejectedCodes', 'hasExternalRejectedCodes', 'canInvoicedSelectedSalesOrder', 'selectedSalesOrderTagType','selectedSalesOrderConfirmedStatus','canConfirmSelectedSalesOrder','getSelectedSalesOrderRemainingQuantities','canEditSelectedSalesOrder','canCancelSelectedSalesOrder','canDeleteSelectedSalesOrder','customerName','canReturnToDraft','canReturnToConfirmed','getCreditItemLineTotal','isSelectedSalesOrderQuantitiesValid', 'isInProblem', 'isLocationInvalid', 'isRepCanEdit']),
      ...mapGetters('controlData', [ 'deliveryTypeByLanguage']),
      ...mapState('inventory', ['inventories']),
      ...mapGetters(['isSAQProcessModuleactive', 'isInvoicingModuleactive', 'isCurrentUserAdmin']),
    },
    created(){
      window.addEventListener('resize', this.handleResize)
      this.handleResize();

      if (_.get(this.$route, 'query.activeTab') === 'packages') {
        this.activeTab = 'packages';
      } else if (_.get(this.$route, 'query.activeTab') === 'invoices') {
        this.activeTab = 'invoices';
      }

    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted(){
      if(this.window.width<1028){
        this.showMoreInfos=false;
        this.showMoreBillingInfos = false;
        this.showMoreShippingInfos = false;
      }
      return Promise.all([
      this.fetchInvoiceStatuses(),
      this.fetchDeliveryTypes(),
      ]).then(() => {
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      })
      
      
    }
  }
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.strike{
  text-decoration: line-through;
}

.addedItem{
  color : #5f8fdf;
}
.modifiedItem{
  color : #ec205f;
}

.el-alert{
  margin-bottom:10px;
}

.page-salesOrder{


	.salesOrder {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 800px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.salesOrder-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				 float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				overflow: hidden;
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.salesOrder-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.deliveryDate{
				display: block;
				float:right;
				margin-top:20px;

				& > * {
					margin: 0;
				}
				.infoDelivery {
					font-weight:bold;

				}


			}

			.notes {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.salesOrder-bottom {

			table {
				width: 100%;
				border-collapse: collapse;

				th {
					// text-align: right;
					// padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					// padding-bottom: 5px;
					border-bottom: 1px solid #EEE;
					font-size:13px;
          vertical-align:top;


					&:first-child {
						text-align: left;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
          padding:0px;
					padding-top: 5px;
          text-align:right;
          &:first-child {
						text-align: right;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}
			}

		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 900px) {
	.page-salesOrder {
		.salesOrder {
			.salesOrder-middle {
				.notes {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;

				}
				.info {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;


				}
			}
			.salesOrder-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-salesOrder {

		.salesOrder {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
